import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import parse from 'dayjs/plugin/customParseFormat';
import pt from 'dayjs/locale/pt-br';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(parse);

const tz = 'America/Sao_Paulo';
dayjs.tz.setDefault(tz);
dayjs.locale(pt);

export function removeTime(date: Date) {
  const formatted = dayjs(date).format('DD/MM/YYYY');

  return dayjs(formatted, 'DD/MM/YYYY');
}

export { dayjs, tz };
